import { useState, useRef, useEffect, HTMLAttributes } from 'react'

import { LOCALE } from '@hhgtech/hhg-components/types'
import { v4 as uuidv4 } from 'uuid'

import { useRouterExtend } from 'hooks/useRouterExtend'

import { AdBlock } from './index'
import { StyledFixedAdBlock } from './index.styled'

export type Props = {
  className?: string
  isMobile?: boolean
  divId?: string
  adUnitPath: string
  contentId?: string
  ignoreRefreshAd?: boolean
  customTargetings?: { [key: string]: (string | number) | (string | number)[] }
} & HTMLAttributes<HTMLDivElement>

const FixedBottomAdBlock = ({
  className = '',
  adUnitPath,
  divId,
  isMobile,
  contentId,
  ignoreRefreshAd = false,
  customTargetings,
  ...rest
}: Props) => {
  const { locale } = useRouterExtend()
  const [hideAd, setHideAd] = useState(true)
  const [userHideAd, setUserHideAd] = useState(false)
  const [hidden, setHidden] = useState(true)
  const adRef = useRef<HTMLDivElement>(null)
  const mountRandRef = useRef<any>(uuidv4())
  const fixedAdRef = useRef<HTMLDivElement>(null)
  const timeoutRef = useRef<NodeJS.Timeout>()
  const closeBtnTimeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    const checkAdShowing = () => {
      if (closeBtnTimeoutRef.current) clearTimeout(closeBtnTimeoutRef.current)
      closeBtnTimeoutRef.current = setTimeout(() => {
        if (document.getElementById('subot--container')) {
          setHideAd(true)
        } else {
          setHideAd(false)
          if (!adRef.current?.clientHeight) {
            setHidden(true)
          } else {
            setHidden(false)
          }
        }
        checkAdShowing()
      }, 4000)
    }
    checkAdShowing()
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current)
      closeBtnTimeoutRef.current && clearTimeout(closeBtnTimeoutRef.current)
    }
  }, [])
  if (hideAd || userHideAd) return null
  return (
    <StyledFixedAdBlock
      key={isMobile ? 'mobile' : 'desktop'}
      ref={fixedAdRef}
      className={`${className} sticky-bottom-ad`}
      data-visible={!hidden}
      {...rest}
    >
      {adUnitPath && (
        <AdBlock
          wrapperProps={{ m: 0 }}
          ref={adRef}
          adUnitPath={adUnitPath}
          size={
            isMobile
              ? [
                  [320, 50],
                  [320, 100],
                ]
              : [728, 90]
          }
          divId={
            (divId || 'div-gpt-ad-sticky') +
            (isMobile ? '-mobile' : '') +
            contentId +
            String(mountRandRef.current)
          }
          pos={['Sticky']}
          contentId={contentId}
          hideIfHasSubot={isMobile}
          customTargetings={customTargetings}
          adDefaultSize={isMobile ? [320, 50] : [728, 90]}
          showCloseBtn
          onCloseAd={() => setUserHideAd(true)}
          refreshInterval={locale === LOCALE.Vietnam ? 30 : 60}
          ignoreRefreshAd={ignoreRefreshAd}
        />
      )}
    </StyledFixedAdBlock>
  )
}

export { FixedBottomAdBlock }
